<template>
    <div class="col-md-12 col-lg-3 col-xl-3">
        <!-- Cat Sidebar Start -->
        <div class="cat-filter mb-3 mb-lg-0">

            <div class="accordion filter-accordion" id="accordionPanelsStayOpenExample">
                <div class="filter-header">
                    <button type="button" class="btn-close" aria-label="Close"></button>
                </div>
                <div class="accordion-item" v-if="filter_inputs" v-for="(input,index)  in filter_inputs" :key="index">
                    <h2 class="accordion-header">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                :data-bs-target="'#'+input.id" aria-expanded="true"
                                :aria-controls="input.id">
                            {{ input.name }}
                        </button>
                    </h2>
                    <div :id="input.id" class="accordion-collapse collapse">
                        <div class="accordion-body">
                            <div class="form-group mb-0">
                                <div class="form-check custom-check"
                                     v-for="(value,index) in input.product_section_inputs" :key="index">
                                    <input class="form-check-input" type="checkbox"
                                           :id="value.input_id" v-model="form.filterInput[input.name+value.id]"
                                           @change.prevent="checked(value.id)" :checked="value.input_id===selecFitler">
                                    <label class="form-check-label" :for="value.input_id" v-model="form.color">
                                        {{ value.input_value }}

                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive"
                                aria-expanded="false" aria-controls="panelsStayOpen-collapseFive">
                            Color
                        </button>
                    </h2>
                    <div id="panelsStayOpen-collapseFive" class="accordion-collapse collapse">
                        <div class="accordion-body">
                            <div class="form-group mb-0">
                                <div class="form-check custom-check">
                                    <input class="form-check-input" type="checkbox" value=""
                                           id="defaultCheck9">
                                    <label class="form-check-label" for="defaultCheck9">
                                        Chromes (77)
                                    </label>
                                </div>
                            </div>
                            <div class="form-group mb-0">
                                <div class="form-check custom-check">
                                    <input class="form-check-input" type="checkbox" value=""
                                           id="defaultCheck10">
                                    <label class="form-check-label" for="defaultCheck10">
                                        Nickel Tones (77)
                                    </label>
                                </div>
                            </div>
                            <div class="form-group mb-0">
                                <div class="form-check custom-check">
                                    <input class="form-check-input" type="checkbox" value=""
                                           id="defaultCheck11">
                                    <label class="form-check-label" for="defaultCheck11">
                                        Stainless Steel (77)
                                    </label>
                                </div>
                            </div>
                            <div class="form-group mb-0">
                                <div class="form-check custom-check">
                                    <input class="form-check-input" type="checkbox" value=""
                                           id="defaultCheck12">
                                    <label class="form-check-label" for="defaultCheck12">
                                        Bronze Tones (77)
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <!-- Cat Sidebar End -->
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {

    props: ['filterInputs'],

    data() {
        return {
            filter_inputs: [],
            form: {
                name: [],
                filterInput: {}

            },
            selecFitler:'',


        }
    },

    computed: {
        ...mapGetters({
            showroomId: 'Common/MyItem',
            productCategory: 'Common/ProductCategory',
        })

    },

    methods: {
        checked(value) {

            this.selecFitler=value

            //console.log(this.form.filterInput);
        },
    },

    mounted() {




    }
}
</script>
